import { HoopsApi, useAPIAction } from "melco-shared-logic";

export const useUploadHoopPreviewAsset = (hoopCloudId: string) => {
  const [uploadHoopPreviewAsset] = useAPIAction(
    HoopsApi,
    async (api, file: Blob) => {
      let response = await api.hoopsUploadPreview({
        id: hoopCloudId,
        file: file,
      });

      return {
        successMessages: [{ message: "default" }],
        data: response,
      };
    },
    {
      translationPrefix: "managehoops.actions.assetuploadpreview",
    }
  );
  return {
    uploadHoopPreviewAsset,
  } as const;
};
